import { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { QueriesList } from '../../@constants/Queries';
import { useRootContext } from '../../components/RootContainer';
import { Breadcrumb } from './Breadcrumb';

/**
 * Dynamic breadcrumb that fetches group reservation name
 * Used instead of loader-based breadcrumb for better UX
 */
export const DynamicGroupReservationBreadcrumb: FC = () => {
  const { id } = useParams();
  const {
    HotelApi: {
      reservations: {
        groupReservation: { getById },
      },
    },
  } = useRootContext();

  const { data } = useQuery({
    queryKey: [QueriesList.RESERVATION_GROUP_DETAILS, `${id}`],
    queryFn: () => getById(Number(id)),
    enabled: Boolean(id),
    staleTime: 30000,
  });

  const label = data?.group_name || 'Loading...';

  return <Breadcrumb label={label} path={null} />;
};
